export default __webpack_public_path__ + "static/media/autorenew.ada4bb62.svg";